import eventsUserSettingsNames from '../events/userSettings';
import { useSendEvent } from '../useSendEvent';

const useProfileClicked = () =>
	useSendEvent(eventsUserSettingsNames.profileClick);

const useContentClicked = () =>
	useSendEvent(eventsUserSettingsNames.contentClick);

const useSecurityClicked = () =>
	useSendEvent(eventsUserSettingsNames.securityClick);

const useCloseClicked = () => useSendEvent(eventsUserSettingsNames.closeClick);

const useProfileSaveClicked = () =>
	useSendEvent<{ name: string; bio: string }>(
		eventsUserSettingsNames.profileSaveClick
	);

const useProfileBackClicked = () =>
	useSendEvent(eventsUserSettingsNames.profileBackClick);

const useContentSaveClicked = () =>
	useSendEvent<{
		gender: string;
		looking_for_gender: string;
		preferable_age: string;
		fantasies: string;
	}>(eventsUserSettingsNames.contentSaveClick);

const useContentBackClicked = () =>
	useSendEvent(eventsUserSettingsNames.contentBackClick);

const useSecuritySaveClicked = () =>
	useSendEvent(eventsUserSettingsNames.securitySaveClick);

const useSecurityBackClicked = () =>
	useSendEvent(eventsUserSettingsNames.securityBackClick);

const annalsUserSettings = {
	useProfileClicked,
	useContentClicked,
	useSecurityClicked,
	useCloseClicked,
	useProfileSaveClicked,
	useProfileBackClicked,
	useContentSaveClicked,
	useContentBackClicked,
	useSecuritySaveClicked,
	useSecurityBackClicked,
};

export default annalsUserSettings;
